import { render, staticRenderFns } from "./DownloadModal.vue?vue&type=template&id=59b213d8&scoped=true"
import script from "./DownloadModal.vue?vue&type=script&lang=js"
export * from "./DownloadModal.vue?vue&type=script&lang=js"
import style0 from "./DownloadModal.vue?vue&type=style&index=0&id=59b213d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b213d8",
  null
  
)

export default component.exports